<template>
  <div>
    <div v-show="step == 1">
      <div class="v-content-card row m-0 p-3">
        <div class="col-md-6 pt-0 pb-0">
          <input
            type="date"
            v-model="paid_in_date"
            class="form-control form-control-sm"
          />
        </div>
        <div class="col-md-6 pt-0 pb-0">
          Agendado para {{ moment(data.due_date).format("DD/MM/YYYY") }}
        </div>
      </div>

      <div class="v-content-card p-3">
        <div class="row" v-for="(item, key) in items" :key="key">
          <div
            class="col-md-12 pt-0 pb-0 c-warning text-right"
            v-if="item.resident_account"
          >
            LANÇAMENTO FATURADO
          </div>
          <div class="col-md-6">
            <input
              :disabled="item.resident_account == 1"
              type="text"
              v-model="item.description"
              class="form-control form-control-sm"
            />
          </div>
          <div class="col-md-2">
            <select
              disabled
              v-model="item.spent_or_gain"
              class="form-control form-control-sm"
              @change="handleSpentOrGainItem(key)"
            >
              <option value="DEBITO">DÉBITO</option>
              <option value="CREDITO">CRÉDITO</option>
            </select>
          </div>
          <div class="col-md-4">
            <!-- :disabled="item.resident_account == 1" -->
            <input
              :id="`input-value-${item.id}`"
              type="text"
              @input="handleInputValue($event.target.value, key)"
              v-model="item.new_value"
              :class="[
                'form-control form-control-sm',
                item.spent_or_gain == 'DEBITO' && 'c-danger',
                item.spent_or_gain == 'CREDITO' && 'c-success',
              ]"
            />
          </div>
          <div
            v-show="item.spent_or_gain == 'DEBITO'"
            class="col-md-6 pt-0 pb-0"
          >
            <label>Fornecedor</label>
            <select
              v-model="item.provider_id"
              class="form-control form-control-sm"
            >
              <option :value="null">SELECIONE...</option>
              <option
                v-for="provider in providers"
                :key="provider.id"
                :value="provider.id"
              >
                {{ provider.company_name }}
              </option>
            </select>
          </div>
          <div
            v-show="item.spent_or_gain == 'CREDITO'"
            class="col-md-6 pt-0 pb-0"
          >
            <label>Cliente</label>
            <select
              :disabled="item.resident_account == 1"
              v-model="item.finance_client_id"
              class="form-control form-control-sm"
            >
              <option :value="null">SELECIONE...</option>
              <option
                v-for="client in finance_client"
                :key="client.id"
                :value="client.id"
              >
                {{
                  `${client.resident_id ? "(RESIDENTE) - " : ""}${client.name}`
                }}
              </option>
            </select>
          </div>
          <div class="col-md-6 pt-0 pb-0">
            <label>Forma de pagamento</label>
            <select
              v-model="item.finance_configuration_payment_methods_id"
              class="form-control form-control-sm"
            >
              <option :value="null">SELECIONE...</option>
              <option
                v-for="payment_method in finance_configuration_payment_methods"
                :key="payment_method.id"
                :value="payment_method.id"
              >
                {{ payment_method.description }}
              </option>
            </select>
          </div>
          <div class="col-md-12 pt-0 pb-0"><hr /></div>
        </div>
      </div>

      <div class="v-content-card row m-0 p-3">
        <div class="col-md-6 pt-0 pb-0">Valor original</div>
        <div
          :class="[
            'col-md-6 pt-0 pb-0 text-right',
            data.is_spent_or_gain == 'DEBITO' ? 'c-danger' : 'c-success',
          ]"
        >
          {{ data.is_spent_or_gain == "DEBITO" ? "-" : "" }}
          {{ formatMoney(String(original_value)) }}
        </div>

        <div class="col-md-6 pt-0 pb-0">Valor pago</div>
        <div
          :class="[
            'col-md-6 pt-0 pb-0 text-right',
            totalDebt < totalCredit && 'c-success',
            totalDebt >= totalCredit && 'c-danger',
          ]"
        >
          {{ totalDebt >= totalCredit ? "-" : "" }}
          {{ formatMoney(String(paid_value)) }}
        </div>

        <div class="col-md-6 pt-0 pb-0">Diferença</div>
        <div :class="['col-md-6 pt-0 pb-0 text-right c-success']">
          {{ formatMoney(String(diff_value)) }}
        </div>
      </div>

      <div class="v-content-card row m-0 p-3">
        <div class="col-md-6 pt-0 pb-0">
          <label>Conta</label>
          <select
            v-model="finance_configuration_account_id"
            class="form-control form-control-sm"
          >
            <option :value="null">SELECIONE...</option>
            <option
              v-for="account in finance_configuration_account"
              :key="account.id"
              :value="account.id"
            >
              {{ account.account_nickname }} -
              {{ formatValueOnKeyUp(account.balance_date) }}
            </option>
          </select>
        </div>
        <div class="col-md-6 pt-0 pb-0">
          <label>Tipo de documento</label>
          <select
            v-model="finance_configuration_document_types_id"
            class="form-control form-control-sm"
          >
            <option :value="null">SELECIONE...</option>
            <option
              v-for="document_type in finance_configuration_document_types"
              :key="document_type.id"
              :value="document_type.id"
            >
              {{ document_type.description }}
            </option>
          </select>
        </div>
        <div class="col-md-6 pt-0 pb-0">
          <label>Número do documento</label>
          <input
            type="text"
            class="form-control form-control-sm"
            v-model="document_number"
          />
        </div>
        <div class="col-md-6 pt-0 pb-0">
          <label>Competência</label>
          <input
            type="date"
            class="form-control form-control-sm"
            v-model="competence"
          />
        </div>
      </div>

      <div
        v-if="lower_value || higher_value"
        class="v-content-card text-center p-3"
      >
        <p class="worksansr m-0">
          Existe uma diferença entre o valor original e o valor pago.
        </p>
        <p class="worksansr">
          Deseja gerar um lançamento com o valor da diferença?
        </p>
        <v-btn class="btn-delete" :disabled="loading" @click="handleNextStep"
          >NÃO, QUERO APENAS
          {{ data.type == "CONTAS_A_PAGAR" ? "PAGAR" : "RECEBER" }} ESTE
          AGENDAMENTO</v-btn
        >
        <span class="m-1"></span>
        <v-btn class="btn-save" :disabled="loading" @click="payAndCreateItem"
          >SIM</v-btn
        >
      </div>

      <ErrorsMessages :errors="errors" />

      <div class="v-content-card row m-0 p-3">
        <div class="col-md-6">
          <v-btn class="btn-cancel mr-2" @click="handleCancel">CANCELAR</v-btn>
        </div>

        <div class="col-md-6 text-right">
          <v-btn
            :disabled="lower_value || higher_value"
            @click="pay"
            class="btn-save"
            ><i class="fas fa-check mr-2"></i>
            {{ data.type == "CONTAS_A_PAGAR" ? "PAGAR" : "RECEBER" }}
          </v-btn>
        </div>
      </div>
    </div>

    <div v-show="step == 2" class="v-content-card row m-0 p-3">
      <div class="col-md-12 pt-0 pb-0 text-center">
        <h5 class="worksansr">
          Deseja {{ data.type == "CONTAS_A_PAGAR" ? "pagar" : "receber" }} o
          valor ou gerar a categoria do valor da diferença?
        </h5>
        <hr />
      </div>
      <div class="col-md-12 pt-0 pb-0">
        <ErrorsMessages :errors="errors" />
      </div>
      <div class="col-md-12 pb-0">
        <v-btn class="btn-edit btn-block" @click="handleNextStep"
          ><i class="fas fa-arrow-right mr-2"></i>QUERO
          {{ data.type == "CONTAS_A_PAGAR" ? "PAGAR" : "RECEBER" }} E GERAR A
          CATEGORIA DA DIFERENÇA</v-btn
        >
      </div>
      <div class="col-md-12 pb-0">
        <v-btn class="btn-save btn-block" @click="pay"
          ><i class="fas fa-check mr-2"></i>QUERO
          {{ data.type == "CONTAS_A_PAGAR" ? "PAGAR" : "RECEBER" }} SEM GERAR A
          CATEGORIA DA DIFERENÇA</v-btn
        >
      </div>
      <div class="col-md-12 pb-0">
        <v-btn class="btn-cancel btn-block" @click="handlePrevStep"
          ><i class="fas fa-arrow-left mr-2"></i> Voltar</v-btn
        >
      </div>
    </div>

    <div v-show="step == 3">
      <div class="v-content-card text-right p-3">
        <b-modal
          size="lg"
          centered
          no-close-on-backdrop
          hide-footer
          hide-header-close
          id="addCredit"
          title="ADICIONAR CRÉDITO"
        >
          <AddCredit
            :providers="providers"
            :finance_client="finance_client"
            :finance_configuration_account="finance_configuration_account"
            :finance_configuration_document_types="
              finance_configuration_document_types
            "
            :finance_configuration_payment_methods="
              finance_configuration_payment_methods
            "
            :finance_configuration_category="finance_configuration_category"
            :finance_configuration_profit_cost_center="
              finance_configuration_profit_cost_center
            "
            :finance_configuration_tag="finance_configuration_tag"
            :cost_types="cost_types"
            :cost_appropriations="cost_appropriations"
            @success="handleSuccessAddCredit"
            @cancel="handleCancelAddCredit"
          />
        </b-modal>
        <v-btn class="btn-save" @click="handleModalAddCredit"
          ><i class="fas fa-plus mr-2"></i>ADICIONAR CRÉDITO</v-btn
        >
      </div>

      <div
        v-if="itemsCredit.length == 0"
        class="v-content-card text-center p-2"
      >
        Não foi adicionado crédito!
      </div>

      <div
        class="v-content-card row m-0 p-3"
        v-for="(itemCredit, key) in itemsCredit"
        :key="key"
      >
        <div class="col-md-10 pt-0 pb-0">
          <div class="row">
            <div class="col-md-8 pt-0 pb-0">
              <label>Descrição</label>
              <input
                type="text"
                v-model="itemCredit.description"
                class="form-control form-control-sm"
              />
            </div>
            <div class="col-md-4 pt-0 pb-0">
              <label>Valor</label>
              <input
                type="text"
                @input="handleInputValueCredit($event.target.value, key)"
                v-model="itemCredit.value"
                class="form-control form-control-sm c-success"
              />
            </div>
            <div class="col-md-6 pt-0 pb-0">
              <label>Categoria</label>
              <treeselect
                :options="finance_configuration_category"
                placeholder="SELECIONE..."
                v-model="itemCredit.finance_configuration_category_id"
                noChildrenText="NÃO POSSUI CATEGORIA(S) FILHA(S)"
              />
            </div>
            <div class="col-md-6 pt-0 pb-0">
              <label>Centro de custo/lucro</label>
              <select
                v-model="itemCredit.finance_configuration_profit_cost_center_id"
                class="form-control form-control-sm"
              >
                <option :value="null">SELECIONE...</option>
                <option
                  v-for="profit_cost_center in finance_configuration_profit_cost_center"
                  :key="profit_cost_center.id"
                  :value="profit_cost_center.id"
                >
                  {{ profit_cost_center.description }}
                </option>
              </select>
            </div>
            <div class="col-md-6 pt-0 pb-0">
              <label>Cliente</label>
              <select
                v-model="itemCredit.finance_client_id"
                class="form-control form-control-sm"
              >
                <option :value="null">SELECIONE...</option>
                <option
                  v-for="client in finance_client"
                  :key="client.id"
                  :value="client.id"
                >
                  {{
                    `${client.resident_id ? "(RESIDENTE) - " : ""}${
                      client.name
                    }`
                  }}
                </option>
              </select>
            </div>
            <div class="col-md-6 pt-0 pb-0">
              <label>Forma de pagamento</label>
              <select
                v-model="itemCredit.finance_configuration_payment_methods_id"
                class="form-control form-control-sm"
              >
                <option :value="null">SELECIONE...</option>
                <option
                  v-for="payment_method in finance_configuration_payment_methods"
                  :key="payment_method.id"
                  :value="payment_method.id"
                >
                  {{ payment_method.description }}
                </option>
              </select>
            </div>
            <div class="col-md-6 pt-0 pb-0">
              <label>Tipo de custo</label>
              <select
                v-model="itemCredit.cost_type"
                class="form-control form-control-sm"
              >
                <option :value="null">SELECIONE...</option>
                <option
                  v-for="type in cost_types"
                  :key="type.value"
                  :value="type.value"
                >
                  {{ type.description }}
                </option>
              </select>
            </div>
            <div class="col-md-6 pt-0 pb-0">
              <label>Apropriação de custo</label>
              <select
                v-model="itemCredit.cost_appropriation"
                class="form-control form-control-sm"
              >
                <option :value="null">SELECIONE...</option>
                <option
                  v-for="appropriation in cost_appropriations"
                  :key="appropriation.value"
                  :value="appropriation.value"
                >
                  {{ appropriation.description }}
                </option>
              </select>
            </div>
            <div class="col-md-12 pt-0 pb-0">
              <vs-select
                label="Tags"
                class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pb-0 pl-0 pr-0"
                placeholder="SELECIONE..."
                multiple
                autocomplete
                v-model="itemCredit.finance_configuration_tag_ids"
              >
                <vs-select-item
                  v-for="tag in finance_configuration_tag"
                  :key="tag.id"
                  :text="tag.description"
                  :value="tag.id"
                />
              </vs-select>
            </div>
          </div>
        </div>
        <div
          class="col-md-2 d-flex align-items-center justify-content-center pt-0 pb-0"
        >
          <confirmation-dialog
            small
            headerClass="modal-header-i"
            message-title="REMOVER?"
            :message-body="`Deseja realmente remover o item?`"
            open-class="btn-delete"
            open-left-icon="fa-times"
            @yes="handleRemoveItemCredit(key)"
          />
        </div>
      </div>

      <div class="v-content-card text-right p-3">
        <b-modal
          size="lg"
          centered
          no-close-on-backdrop
          hide-footer
          hide-header-close
          id="addDebt"
          title="ADICIONAR DÉBITO"
        >
          <AddDebt
            :providers="providers"
            :finance_client="finance_client"
            :finance_configuration_account="finance_configuration_account"
            :finance_configuration_document_types="
              finance_configuration_document_types
            "
            :finance_configuration_payment_methods="
              finance_configuration_payment_methods
            "
            :finance_configuration_category="finance_configuration_category"
            :finance_configuration_profit_cost_center="
              finance_configuration_profit_cost_center
            "
            :finance_configuration_tag="finance_configuration_tag"
            :cost_types="cost_types"
            :cost_appropriations="cost_appropriations"
            @success="handleSuccessAddDebt"
            @cancel="handleCancelAddDebt"
          />
        </b-modal>
        <v-btn class="btn-delete" @click="handleModalAddDebt"
          ><i class="fas fa-plus mr-2"></i>ADICIONAR DÉBITO</v-btn
        >
      </div>

      <div v-if="itemsDebt.length == 0" class="v-content-card text-center p-2">
        Não foi adicionado débito!
      </div>

      <div
        class="v-content-card row m-0 p-3"
        v-for="(itemDebt, key) in itemsDebt"
        :key="key"
      >
        <div class="col-md-10 pt-0 pb-0">
          <div class="row">
            <div class="col-md-8 pt-0 pb-0">
              <label>Descrição</label>
              <input
                type="text"
                v-model="itemDebt.description"
                class="form-control form-control-sm"
              />
            </div>
            <div class="col-md-4 pt-0 pb-0">
              <label>Valor</label>
              <input
                type="text"
                @input="handleInputValueDebt($event.target.value, key)"
                v-model="itemDebt.value"
                class="form-control form-control-sm c-danger"
              />
            </div>
            <div class="col-md-6 pt-0 pb-0">
              <label>Categoria</label>
              <treeselect
                :options="finance_configuration_category"
                placeholder="SELECIONE..."
                v-model="itemDebt.finance_configuration_category_id"
                noChildrenText="NÃO POSSUI CATEGORIA(S) FILHA(S)"
              />
            </div>
            <div class="col-md-6 pt-0 pb-0">
              <label>Centro de custo/lucro</label>
              <select
                v-model="itemDebt.finance_configuration_profit_cost_center_id"
                class="form-control form-control-sm"
              >
                <option :value="null">SELECIONE...</option>
                <option
                  v-for="profit_cost_center in finance_configuration_profit_cost_center"
                  :key="profit_cost_center.id"
                  :value="profit_cost_center.id"
                >
                  {{ profit_cost_center.description }}
                </option>
              </select>
            </div>
            <div class="col-md-6 pt-0 pb-0">
              <label>Fornecedor</label>
              <select
                v-model="itemDebt.provider_id"
                class="form-control form-control-sm"
              >
                <option :value="null">SELECIONE...</option>
                <option
                  v-for="provider in providers"
                  :key="provider.id"
                  :value="provider.id"
                >
                  {{ provider.company_name }}
                </option>
              </select>
            </div>
            <div class="col-md-6 pt-0 pb-0">
              <label>Forma de pagamento</label>
              <select
                v-model="itemDebt.finance_configuration_payment_methods_id"
                class="form-control form-control-sm"
              >
                <option :value="null">SELECIONE...</option>
                <option
                  v-for="payment_method in finance_configuration_payment_methods"
                  :key="payment_method.id"
                  :value="payment_method.id"
                >
                  {{ payment_method.description }}
                </option>
              </select>
            </div>
            <div class="col-md-6 pt-0 pb-0">
              <label>Tipo de custo</label>
              <select
                v-model="itemDebt.cost_type"
                class="form-control form-control-sm"
              >
                <option :value="null">SELECIONE...</option>
                <option
                  v-for="type in cost_types"
                  :key="type.value"
                  :value="type.value"
                >
                  {{ type.description }}
                </option>
              </select>
            </div>
            <div class="col-md-6 pt-0 pb-0">
              <label>Apropriação de custo</label>
              <select
                v-model="itemDebt.cost_appropriation"
                class="form-control form-control-sm"
              >
                <option :value="null">SELECIONE...</option>
                <option
                  v-for="appropriation in cost_appropriations"
                  :key="appropriation.value"
                  :value="appropriation.value"
                >
                  {{ appropriation.description }}
                </option>
              </select>
            </div>
            <div class="col-md-12 pt-0 pb-0">
              <vs-select
                label="Tags"
                class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pb-0 pl-0 pr-0"
                placeholder="SELECIONE..."
                multiple
                autocomplete
                v-model="itemDebt.finance_configuration_tag_ids"
              >
                <vs-select-item
                  v-for="tag in finance_configuration_tag"
                  :key="tag.id"
                  :text="tag.description"
                  :value="tag.id"
                />
              </vs-select>
            </div>
          </div>
        </div>
        <div
          class="col-md-2 d-flex align-items-center justify-content-center pt-0 pb-0"
        >
          <confirmation-dialog
            small
            headerClass="modal-header-i"
            message-title="REMOVER?"
            :message-body="`Deseja realmente remover o item?`"
            open-class="btn-delete"
            open-left-icon="fa-times"
            @yes="handleRemoveItemDebt(key)"
          />
        </div>
      </div>

      <ErrorsMessages :errors="errors" />

      <div class="v-content-card row m-0 p-3">
        <div class="col-md-6 pb-0">
          <v-btn class="btn-cancel mr-2" @click="handlePrevStep"
            ><i class="fas fa-arrow-left mr-2"></i> Voltar
          </v-btn>
        </div>
        <div class="col-md-6 pb-0 text-right">
          <v-btn
            :disabled="loading"
            @click="payAndCreateCategoryValue"
            class="btn-edit"
            ><i class="fas fa-check mr-2"></i>
            <span v-if="data.type == 'CONTAS_A_PAGAR'">{{
              loading ? "CARREGANDO" : "PAGAR"
            }}</span>
            <span v-if="data.type == 'CONTAS_A_RECEBER'">{{
              loading ? "CARREGANDO" : "RECEBER"
            }}</span>
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../../../Components/ErrorsMessages";

import ConfirmationDialog from "../../../../Components/ConfirmationDialog";

import Treeselect from "@riophae/vue-treeselect";

import AddCredit from "./Pay/AddCredit";

import AddDebt from "./Pay/AddDebt";

import api from "../../../../../services/api";

import moment from "moment";

import {
  formatValueOnKeyUp,
  formatValueNegativeOnKeyUp,
  formatMoney,
  numbersOnly,
} from "../../../../../lib/format";

import toast from "../../../../../lib/ToastNotification";

export default {
  name: "Pay",

  components: {
    ErrorsMessages,
    ConfirmationDialog,
    Treeselect,
    AddCredit,
    AddDebt,
  },

  props: {
    data: Object,
    providers: Array,
    finance_client: Array,
    finance_configuration_account: Array,
    finance_configuration_document_types: Array,
    finance_configuration_payment_methods: Array,
    finance_configuration_category: Array,
    finance_configuration_profit_cost_center: Array,
    finance_configuration_tag: Array,
    cost_types: Array,
    cost_appropriations: Array,
  },

  data() {
    return {
      step: 1,
      paid_in_date: moment().format("YYYY-MM-DD"),
      competence: "",
      finance_configuration_account_id: "",
      finance_configuration_document_types_id: "",
      document_number: "",
      paid_value: 0,
      original_value: 0,
      diff_value: 0,
      totalCredit: 0,
      totalDebt: 0,
      items: [],
      itemsCredit: [],
      itemsDebt: [],
      errors: [],
      higher_value: false,
      lower_value: false,
      loading: false,
      generate: true,
      generate_diff_value: "",
      generate_more_or_less: "",
    };
  },

  created() {
    let { data } = this;

    let totalCredit = 0;
    let totalDebt = 0;
    for (let item of data.items) {
      if (item.spent_or_gain == "DEBITO") {
        item.new_value = formatValueNegativeOnKeyUp(item.value);
      } else {
        item.new_value = formatValueOnKeyUp(item.value);
      }

      if (item.spent_or_gain == "DEBITO") {
        totalDebt = parseFloat(totalDebt) + parseFloat(numbersOnly(item.value));
      }

      if (item.spent_or_gain == "CREDITO") {
        totalCredit =
          parseFloat(totalCredit) + parseFloat(numbersOnly(item.value));
      }
    }

    this.totalCredit = totalCredit;
    this.totalDebt = totalDebt;

    this.items = data.items;
    this.paid_value = data.total;
    this.original_value = data.total;
    this.competence = moment(data.competence).format("YYYY-MM-DD");
    this.finance_configuration_account_id =
      data.finance_configuration_account_id;
    this.finance_configuration_document_types_id =
      data.finance_configuration_document_types_id;
  },

  methods: {
    moment,
    numbersOnly,
    formatMoney,
    formatValueOnKeyUp,
    formatValueNegativeOnKeyUp,

    handlePrevStep() {
      if (this.step > 1) {
        let { items } = this;

        // for (let item of items) {
        //   if (item.spent_or_gain == "DEBITO") {
        //     item.new_value = formatValueNegativeOnKeyUp(String(item.value));
        //   }

        //   if (item.spent_or_gain == "CREDITO") {
        //     item.new_value = formatValueOnKeyUp(String(item.value));
        //   }
        // }

        items;
      }
      this.step = this.step - 1;
      this.errors = [];
    },

    handleNextStep() {
      if (this.step == 2) {
        let {
          generate_diff_value,
          generate_more_or_less,
          itemsDebt,
          itemsCredit,
        } = this;

        if (generate_more_or_less == "more") {
          if (itemsCredit.length == 0) {
            this.itemsCredit.push({
              spent_or_gain: "CREDITO",
              description: "Valor da diferença",
              value: formatValueOnKeyUp(String(generate_diff_value)),
              finance_configuration_category_id: null,
              finance_configuration_profit_cost_center_id: null,
              provider_id: null,
              finance_client_id: null,
              finance_configuration_payment_methods_id: null,
              finance_configuration_tag_ids: [],
              cost_type: null,
              cost_appropriation: null,
            });
            this.itemsDebt = [];
          }
        }

        if (generate_more_or_less == "less") {
          if (itemsDebt.length == 0) {
            this.itemsDebt.push({
              spent_or_gain: "DEBITO",
              description: "Valor da diferença",
              value: formatValueNegativeOnKeyUp(String(generate_diff_value)),
              finance_configuration_category_id: null,
              finance_configuration_profit_cost_center_id: null,
              provider_id: null,
              finance_client_id: null,
              finance_configuration_payment_methods_id: null,
              finance_configuration_tag_ids: [],
              cost_type: null,
              cost_appropriation: null,
            });
            this.itemsCredit = [];
          }
        }
      }

      this.step = this.step + 1;

      this.errors = [];
    },

    handleModalAddCredit() {
      this.$bvModal.show("addCredit");
    },

    handleModalAddDebt() {
      this.$bvModal.show("addDebt");
    },

    handleCancelAddCredit() {
      this.$bvModal.hide("addCredit");
    },

    handleCancelAddDebt() {
      this.$bvModal.hide("addDebt");
    },

    handleSuccessAddCredit(item) {
      this.itemsCredit.push(item);
      this.$bvModal.hide("addCredit");
    },

    handleSuccessAddDebt(item) {
      this.itemsDebt.push(item);
      this.$bvModal.hide("addDebt");
    },

    handleRemoveItemCredit(key) {
      this.itemsCredit.splice(key, 1);
    },

    handleRemoveItemDebt(key) {
      this.itemsDebt.splice(key, 1);
    },

    handleInputValueCredit(value, key) {
      this.itemsCredit[key].value = formatValueOnKeyUp(value);
    },

    handleInputValueDebt(value, key) {
      this.itemsDebt[key].value = formatValueNegativeOnKeyUp(value);
    },

    handleInputValue(new_value, key) {
      let item = this.items[key];
      // let input = document.getElementById(`input-value-${item.id}`);

      new_value = numbersOnly(new_value);

      // if (parseFloat(numbersOnly(new_value)) > parseFloat(item.value)) {
      //   new_value = item.value;

      //   if (item.spent_or_gain == "DEBITO") {
      //     input.value = formatValueNegativeOnKeyUp(String(item.value));
      //     item.new_value = formatValueNegativeOnKeyUp(String(input.value));
      //   } else {
      //     input.value = formatValueOnKeyUp(String(item.value));
      //     item.new_value = formatValueOnKeyUp(String(input.value));
      //   }
      // } else {
      //   input.value = formatValueNegativeOnKeyUp(String(new_value));
      // }

      if (item.spent_or_gain == "DEBITO") {
        item.new_value = formatValueNegativeOnKeyUp(numbersOnly(new_value));
      } else {
        item.new_value = formatValueOnKeyUp(numbersOnly(new_value));
      }

      let { items } = this;

      let totalCredit = 0;
      let totalDebt = 0;
      let totalValue = 0;

      let more = 0;
      let less = 0;

      for (let item of items) {
        if (item.spent_or_gain == "DEBITO") {
          totalDebt =
            parseFloat(totalDebt) + parseFloat(numbersOnly(item.new_value));
          totalValue =
            parseFloat(totalValue) + parseFloat(numbersOnly(item.new_value));
        }

        if (item.spent_or_gain == "CREDITO") {
          totalCredit =
            parseFloat(totalCredit) + parseFloat(numbersOnly(item.new_value));
          totalValue =
            parseFloat(totalValue) - parseFloat(numbersOnly(item.new_value));
        }

        if (parseFloat(numbersOnly(item.new_value)) < parseFloat(item.value)) {
          let value_diff =
            parseFloat(item.value) - parseFloat(numbersOnly(item.new_value));
          less = parseFloat(less) + parseFloat(value_diff);
        }

        if (parseFloat(numbersOnly(item.new_value)) > parseFloat(item.value)) {
          let value_diff =
            parseFloat(numbersOnly(item.new_value)) - parseFloat(item.value);
          more = parseFloat(more) + parseFloat(value_diff);
        }
      }

      if (this.items[key].spent_or_gain == "DEBITO") {
        if (totalValue >= 0) {
          this.paid_value = totalValue;
        } else {
          this.paid_value = totalDebt;
        }

        if (
          parseFloat(totalDebt) <
          parseFloat(this.data.total) + parseFloat(totalCredit)
        ) {
          this.diff_value =
            parseFloat(parseFloat(this.data.total) + parseFloat(totalCredit)) -
            parseFloat(totalDebt);
        } else {
          this.diff_value = 0;
        }
      } else {
        if (parseFloat(totalDebt) >= parseFloat(totalCredit)) {
          this.paid_value = parseFloat(totalDebt) - parseFloat(totalCredit);
        } else {
          this.paid_value = parseFloat(totalCredit) - parseFloat(totalDebt);
        }
      }

      this.totalCredit = totalCredit;
      this.totalDebt = totalDebt;

      let { paid_value, original_value } = this;

      if (parseFloat(more) > 0 && parseFloat(less) > 0) {
        let more_or_less = 0;

        if (parseFloat(more) > parseFloat(less)) {
          more_or_less = parseFloat(more) - parseFloat(less);
          this.generate_more_or_less = "more";
        }

        if (parseFloat(less) > parseFloat(more)) {
          more_or_less = parseFloat(less) - parseFloat(more);
          this.generate_more_or_less = "less";
        }

        this.generate_diff_value = more_or_less;
      }

      if (parseFloat(more) > 0 && parseFloat(less) == 0) {
        this.generate_diff_value = more;
        this.generate_more_or_less = "more";
      }
      if (parseFloat(less) > 0 && parseFloat(more) == 0) {
        this.generate_diff_value = less;
        this.generate_more_or_less = "less";
      }

      if (parseFloat(paid_value) < parseFloat(original_value)) {
        this.higher_value = false;
        this.lower_value = true;
      } else if (parseFloat(paid_value) > parseFloat(original_value)) {
        this.higher_value = true;
        this.lower_value = false;
      } else {
        this.higher_value = false;
        this.lower_value = false;
      }
    },

    handleSpentOrGainItem(key) {
      this.items[key].provider_id = "";
      this.items[key].finance_client_id = "";
      this.handleInputValue(this.items[key].new_value, key);
    },

    handleInputGenerate() {
      this.errors = [];
      this.lower_value_finance_configuration_category_id = "";
    },

    handleModalGenerate() {
      this.errors = [];
      this.$bvModal.show("generate_value");
    },

    async pay() {
      try {
        this.loading = true;

        const {
          data,
          paid_in_date,
          items,
          finance_configuration_account_id,
          finance_configuration_document_types_id,
          document_number,
          competence,
        } = this;

        let itemsParams = [];

        for (let item of items) {
          itemsParams.push({
            id: item.id,
            description: item.description,
            spent_or_gain: item.spent_or_gain,
            value: item.value,
            new_value: item.new_value,
            provider_id: item.provider_id,
            finance_client_id: item.finance_client_id,
            finance_configuration_payment_methods_id:
              item.finance_configuration_payment_methods_id,
          });
        }

        let params = {
          finance_launch_bills_to_pay_installments_id: data.id,
          paid_in_date,
          items: itemsParams,
          finance_configuration_account_id,
          finance_configuration_document_types_id,
          document_number,
          competence,
        };

        const response = await api.post("/rest-home/financial/pay", params);

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");

          this.$emit("success");

          this.errors = [];
        } else {
          this.errors = errors;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async payAndCreateItem() {
      try {
        this.loading = true;

        const {
          data,
          paid_in_date,
          items,
          finance_configuration_account_id,
          finance_configuration_document_types_id,
          document_number,
          competence,
        } = this;

        let itemsParams = [];

        for (let item of items) {
          itemsParams.push({
            id: item.id,
            description: item.description,
            spent_or_gain: item.spent_or_gain,
            value: item.value,
            new_value: item.new_value,
            provider_id: item.provider_id,
            finance_client_id: item.finance_client_id,
            finance_configuration_payment_methods_id:
              item.finance_configuration_payment_methods_id,
            finance_configuration_category_id:
              item.finance_configuration_category_id,
            finance_configuration_tag_ids: item.finance_configuration_tag_ids,
            finance_configuration_profit_cost_center_id:
              item.finance_configuration_profit_cost_center_id,
            cost_type: item.cost_type,
            cost_appropriation: item.cost_appropriation,
          });
        }

        let params = {
          finance_launch_bills_to_pay_installments_id: data.id,
          paid_in_date,
          items: itemsParams,
          finance_configuration_account_id,
          finance_configuration_document_types_id,
          document_number,
          competence,
        };

        const response = await api.post(
          "/rest-home/financial/pay-create-item",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");

          this.$emit("success");

          this.errors = [];
        } else {
          this.errors = errors;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async payAndCreateCategoryValue() {
      try {
        this.loading = true;

        const {
          data,
          paid_in_date,
          items,
          finance_configuration_account_id,
          finance_configuration_document_types_id,
          document_number,
          competence,
          itemsCredit,
          itemsDebt,
        } = this;

        let itemsParams = [];

        for (let item of items) {
          itemsParams.push({
            id: item.id,
            description: item.description,
            spent_or_gain: item.spent_or_gain,
            value: item.value,
            new_value: item.new_value,
            provider_id: item.provider_id,
            finance_client_id: item.finance_client_id,
            finance_configuration_payment_methods_id:
              item.finance_configuration_payment_methods_id,
            finance_configuration_category_id:
              item.finance_configuration_category_id,
            finance_configuration_tag_ids: item.finance_configuration_tag_ids,
            finance_configuration_profit_cost_center_id:
              item.finance_configuration_profit_cost_center_id,
            cost_type: item.cost_type,
            cost_appropriation: item.cost_appropriation,
          });
        }

        let params = {
          finance_launch_bills_to_pay_installments_id: data.id,
          paid_in_date,
          items: itemsParams,
          finance_configuration_account_id,
          finance_configuration_document_types_id,
          document_number,
          competence,
          itemsCredit,
          itemsDebt,
        };

        const response = await api.post(
          "/rest-home/financial/pay-create-category-value",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");

          this.$emit("success");

          this.errors = [];
        } else {
          this.errors = errors;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    handleCancel() {
      this.$emit("cancel");
    },
  },
};
</script>
